module.exports = __webpack_public_path__ + "media/Video18.ad572936.mp4";